
import React, { useEffect, useState, useContext } from "react";
import { getProducts, deleteProduct } from "../api";
import { useNavigate, avigate, Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"


const ProdList1 = ({ id_c }) => {
    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
    const [data, setData] = useState(null);
    //filtros
    const [filterProd, setFilterProd] = useState(""); // filtro por id_prod
    const [filterMachine, setFilterMachine] = useState(""); // filtro por cod_maq

    //const navigate = useNavigate();
    const navigate = useNavigate(); // Hook para navegación




    useEffect(() => {
        const fetchData = async () => {
            const result = await getProducts(id_c);
            setData(result);
        };
        fetchData();
    }, [id_c]);

    if (!data) return <p>{t('MList1')}</p>;


    /*
        const handleDelete = async (id_prod) => {
            if (window.confirm("¿Seguro que deseas eliminar este producto?")) {
                const result = await deleteProduct(id_prod);
                if (result) {
                    alert("✅ Producto eliminado");
                    setData((prev) => ({
                        ...prev,
                        products: prev.products.filter((p) => p.id_prod !== id_prod),
                    }));
                }
            }
        };
    
    */
// --- Normalización de filtros ---
  const filterProdClean = filterProd.trim().toLowerCase();
  const filterMachineClean = filterMachine.trim().toLowerCase();

  // --- Fuente segura de productos ---
  const products = Array.isArray(data?.products) ? data.products : [];

  // --- Aplicación de filtros ---
  const filteredProducts = products.filter((product) => {
    const prodIdStr = product?.id_prod?.toString().toLowerCase() ?? "";
    const codMaqStr = product?.cod_maq?.toString().toLowerCase() ?? "";

    // usa startsWith para misma lógica de BatchList2; cambia a includes si prefieres "contiene"
    return (
      prodIdStr.startsWith(filterProdClean) &&
      codMaqStr.startsWith(filterMachineClean)
    );
  });


    return (
        <div className="box1">
            <div className="box9">
                <button className="button7" onClick={() => navigate("/new_prod")}>
                    {t('prodList11')}


                </button>


        {/* Inputs de búsqueda (idéntico esquema visual a BatchList2) */}
        <div className="table5">
          <input
            type="text"
            placeholder="🔎 Filtrar por producto (ID)"
            value={filterProd}
            onChange={(e) => setFilterProd(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por máquina"
            value={filterMachine}
            onChange={(e) => setFilterMachine(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
        </div>


                <table className="table5">
                    <thead>
                        <tr>
                            <th>{t('prodList4')}</th>
                            <th>{t('prodList14')}</th>
                            <th>{t('prodList3')}</th>
                            <th className="col_width">{t('prodList5')}</th>
                            <th>{t('prodList15')}</th>
                            <th>{t('prodList6')}</th>
                            <th>{t('prodList7')}</th>
                            <th>{t('prodList8')}</th>

                            <th>{t("actType6")}</th>
                            {/*}  <th>{t('prodList9')}</th>
                            <th>{t('prodList10')}</th> */}
                        </tr>
                    </thead>
                   <tbody>
            {filteredProducts.length === 0 ? (
              <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>
                  {t("Sin resultados")}
                </td>
              </tr>
            ) : (
              filteredProducts.map((product, index) => (
                <tr
                  key={`${product.id_prod ?? "noid"}-${product.cod_maq ?? "nomaq"}-${index}`}
                >
                  <td>{product.id_prod}</td>
                  <td>{product.model}</td>
                  <td>{product.cod_maq}</td>
                  <td>{product.name_prod}</td>
                  <td>{product.description_prod}</td>
                  <td>{product.und_prod}</td>
                  <td>{product.ciclo_x_hr_prod_std}</td>
                  <td>{product.und_prod_x_oper}</td>

                  <td>
                    <button
                      className="button"
                      onClick={() => navigate(`/edit_prod/${product.id_prod}`)}
                    >
                      {t("MList7")}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
                </table>

            </div>
        </div>
    );
};

export default ProdList1;